import { Button, Icon } from "@fluentui/react";
import { FieldErrors, FieldValues } from "react-hook-form";

export interface IHeaderActionButton {
    label: string;
    iconName: string;
    onClick: () => void;
    className?: string;
    type?: "button" | "submit" | "reset"; 
    disabled?: boolean;
    colorIcon?:string;
  }
  
  export interface IHeaderReusable {
    title: string;
    actions: IHeaderActionButton[];
    errors?: FieldErrors<FieldValues>;
    onErrors?: (hasError: boolean) => void;
    icontitle?: string;
  }
  
  export default function HeaderReusable({
    title,
    actions,
    icontitle,
  }: IHeaderReusable) {
  
    return (
      <header className="header_emp_create">
      <div className="emp_create_hader_buton">
        <span>
          <Icon
            iconName={icontitle}
            style={{ color: "#0078D4", marginRight: "5px" , fontSize:'22px' }}
          />
          <span>{title}</span>
        </span>
        <div style={{display:'flex',flexDirection:'row'}}>
          {actions.map((action, index) => (
            <Button
              type={action.type || "button"} 
              key={index}
              className={action.disabled?"Button_disabled":action.className}
              disabled={action.disabled}
              onClick={() => {
                action.onClick();
              }}
            >
              <Icon iconName={action.iconName} style={{ marginRight: "5px", color:action.disabled?"#9b9898":action.colorIcon }} />
              <span>{action.label}</span>
            </Button>
          ))}
        </div>
      </div>
      </header>
    );
  }
  